import React from "react";
import { LineClearanceRow } from "../../LineClearance/helpers/lineClearance.types";

interface LineClearanceTableProps {
  checklist: LineClearanceRow[];
  onPharmacistChange?: (index: number, value: "yes" | "no" | "na") => void;
  onQaChange?: (index: number, value: "yes" | "no" | "na") => void;
  onRemarkChange?: (index: number, value: string) => void;
  isDisabled?: boolean;
  hideQaColumns?: boolean;
  isPharmacistDisabled?: boolean;
  isQaDisabled?: boolean;
}

const LineClearanceTable: React.FC<LineClearanceTableProps> = ({
  checklist,
  onPharmacistChange,
  onQaChange,
  onRemarkChange,
  isDisabled = false,
  hideQaColumns = false,
  isPharmacistDisabled = false,
  isQaDisabled = false,
}) => {
  const sectionDividerStyle = { borderRight: "1px solid #94a3b8" };

  return (
    <div className="table-responsive border rounded-3 overflow-hidden shadow-sm">
      <table className="table table-bordered table-sm align-middle text-center mb-0" style={{ fontSize: "12px" }}>
        <thead>
          <tr className="bg-light text-dark fw-bold">
            <th rowSpan={2} style={{ width: "60px", backgroundColor: "#f3f6f9" }} className="align-middle border-end">
              Sr. No.
            </th>
            <th rowSpan={2} style={{ backgroundColor: "#f3f6f9", ...sectionDividerStyle }} className="text-start align-middle">
              Particulars
            </th>
            <th colSpan={3} style={{ backgroundColor: "#eef2f7", ...sectionDividerStyle }} className="text-primary text-center py-2">
              Done By Pharmacist
            </th>
            {!hideQaColumns && (
              <>
                <th colSpan={3} style={{ backgroundColor: "#eef2f7", ...sectionDividerStyle }} className="text-primary text-center py-2">
                  Verified By QA
                </th>
                <th rowSpan={2} style={{ width: "200px", backgroundColor: "#f3f6f9" }} className="align-middle text-center">
                  Remark
                </th>
              </>
            )}
          </tr>
          <tr className="bg-light">
            {/* Pharmacist Yes / No / N/A */}
            <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa" }} className="py-1">
              Yes
            </th>
            <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa" }} className="py-1">
              No
            </th>
            <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa", ...sectionDividerStyle }} className="py-1">
              N/A
            </th>
            {!hideQaColumns && (
              <>
                {/* QA Yes / No / N/A */}
                <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa" }} className="py-1">
                  Yes
                </th>
                <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa" }} className="py-1">
                  No
                </th>
                <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa", ...sectionDividerStyle }} className="py-1">
                  N/A
                </th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {checklist.map((item, idx) => (
            <tr key={item.id || idx} className="hover-row">
              <td className="fw-semibold text-muted text-center">{idx + 1}</td>
              <td className="text-start fw-medium px-3" style={sectionDividerStyle}>
                {item.particulars}
              </td>

              {/* Done By Pharmacist Radio Group */}
              {(["yes", "no", "na"] as const).map((val) => (
                <td
                  key={`pharm_${val}`}
                  className="text-center"
                  style={val === "na" ? sectionDividerStyle : undefined}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <input
                      type="radio"
                      className="form-check-input my-0 cursor-pointer"
                      name={`pharmacist_info_${idx}`}
                      checked={item.pharmacistInfo === val}
                      onChange={() => onPharmacistChange?.(idx, val)}
                      disabled={isDisabled || isPharmacistDisabled}
                    />
                  </div>
                </td>
              ))}

              {!hideQaColumns && (
                <>
                  {/* Verified By QA Radio Group */}
                  {(["yes", "no", "na"] as const).map((val) => (
                    <td
                      key={`qa_${val}`}
                      className="text-center"
                      style={val === "na" ? sectionDividerStyle : undefined}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <input
                          type="radio"
                          className="form-check-input my-0 cursor-pointer"
                          name={`qa_info_${idx}`}
                          checked={item.qaInfo === val}
                          onChange={() => onQaChange?.(idx, val)}
                          disabled={isDisabled || isQaDisabled}
                        />
                      </div>
                    </td>
                  ))}

                  {/* QA Remarks Column */}
                  <td className="text-center p-1">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      style={{ fontSize: "12px" }}
                      placeholder="Enter remarks..."
                      value={item.qaRemark || ""}
                      onChange={(e) => onRemarkChange?.(idx, e.target.value)}
                      disabled={isDisabled || isQaDisabled}
                    />
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LineClearanceTable;
